require('./subscriptionStatusController');

'use strict';

angular.module('app.currentUser.subscriptionStatus.subscriptionStatusDirective', [
    'app.currentUser.subscriptionStatus.subscriptionStatusController'
])
    .directive('subscriptionStatus', [
        function () {
            return {
                restrict: 'EA',
                templateUrl: 'components/fhApp/currentUser/subscriptionStatus/subscriptionStatusView.html',
                controller: 'app.currentUser.subscriptionStatus.subscriptionStatusController',
                scope: {
                    hideProgress: '<',
                    hideIfNotExists: '<',
                    hideManage: '<',
                    autoRenew: '<',
                    subscription: '<'
                }
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/currentUser/subscriptionStatus/subscriptionStatusDirective.js